import { GetRandomSalt } from "../helpers/Utils";

export default class Notification {
  constructor(obj) {
    // acutal content
    this.title = null;
    this.icon = null;
    this.body = null;
    this.poiId = null;
    this.group = null;

    // internal content only
    this.id = GetRandomSalt(12);
    this.seen = false;
    this.receivedDate = new Date();

    if (obj) {
      if (obj.title) {
        this.title = obj.title;
      }
      if (obj.Title) {
        this.title = obj.Title;
      }

      if (obj.icon) {
        this.icon = obj.icon;
      }
      if (obj.Icon) {
        this.icon = obj.Icon;
      }

      if (obj.body) {
        this.body = obj.body;
      }
      if (obj.Body) {
        this.body = obj.Body;
      }

      if(obj.id) {
        this.poiId = obj.id;
      }

      if(obj.group) {
        this.group = obj.group;
      }
    }
  }
}
